import { NavLink } from 'react-router-dom';
import { Container } from '@dma/ui';
import './Header.css';

const NAV_LINKS = [
  { to: '/', label: 'صفحه اصلی', end: true },
  { to: '/about', label: 'درباره ما' },
  { to: '/projects', label: 'پروژه‌ها' },
  { to: '/services', label: 'خدمات' },
  { to: '/minerals', label: 'محصولات' },
  { to: '/mineralogy', label: 'کانی‌شناسی' },
  { to: '/petrology', label: 'سنگ‌شناسی' },
  { to: '/news', label: 'اخبار' },
  { to: '/articles', label: 'مقالات' },
  { to: '/gallery', label: 'گالری' },
  { to: '/contact', label: 'تماس با ما' }
];

/**
 * Global site header. Real logo added 2026-08-18 (see
 * public/images/logo.jpg) — previously text-only. Navigation links added
 * at the same time: with 9 public features now implemented, a header with
 * no nav meant visitors could only reach any page but Home by typing its
 * URL directly, which had been an open gap since the header was first
 * scaffolded (see git history / prior README notes).
 */
export function Header() {
  return (
    <header className="dma-header">
      <Container>
        <div className="dma-header__inner">
          <NavLink to="/" className="dma-header__brand">
            <span className="dma-header__logo-badge">
              <img src="/images/logo.jpg" alt="داریوش معدن آذر" className="dma-header__logo" />
            </span>
          </NavLink>
          <nav className="dma-header__nav" aria-label="ناوبری اصلی">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  isActive ? 'dma-header__nav-link dma-header__nav-link--active' : 'dma-header__nav-link'
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </Container>
    </header>
  );
}
